<script>import { t, Verbiage } from "@infinitro/content";
import { CheckIcon, IncorrectIcon, RemoveIcon } from "@infinitro/icons";
import { Input } from "@infinitro/input";
import { stateReferalCode, stateReferalCodeConfirmed } from "../state";
let element;
let confirmed = false;
let incorrect = false;
const BASE32_REGEX = /^[A-Z2-7]{6}$/;
const sanitize = (value) => value.toUpperCase().replace(/[^A-Z2-7]/g, "").slice(0, 6);
const onChange = () => {
  element.value = sanitize(element.value);
  if (BASE32_REGEX.test(element.value)) {
    stateReferalCode.set(element.value);
  } else {
    stateReferalCode.set("");
  }
};
const onBlur = (event) => {
  const _valid = element.value.length > 0 && element.checkValidity();
  if (_valid && !confirmed) {
    confirmReferalCode(event);
  }
};
export const confirmReferalCode = (event) => {
  event.preventDefault();
  return new Promise((resolve) => {
    let resolved = false;
    if (!element.checkValidity() || confirmed) return;
    try {
      resolve(false);
    } catch (e) {
      console.log(`caught ${e}`);
      stateReferalCodeConfirmed.set(false);
    }
  });
};
const onRemove = (event) => {
  event.preventDefault();
  stateReferalCode.set("");
  stateReferalCodeConfirmed.set(false);
  confirmed = false;
};
stateReferalCode.subscribe((_value) => {
  if (_value) {
    if (element) element.value = _value;
  }
});
stateReferalCodeConfirmed.subscribe((value) => {
  confirmed = value;
});
</script>

<span class="section">
	<div class="input">
		<Input
			id="referalcode"
			name="referalcode"
			type="text"
			placeholder={$t(Verbiage.referal_code)}
			disabled={confirmed}
			bind:element
			bind:error={incorrect}
			on:input={onChange}
			on:blur={onBlur}
		/>
		{#if confirmed}
			<a class="trailing-icon" href={'#'} on:click={onRemove} tabindex="-1">
				<RemoveIcon />
			</a>
		{/if}
	</div>
	{#if incorrect}<IncorrectIcon />{:else if confirmed}
		<CheckIcon />
	{/if}
</span>

<style>
	.section {
    display: flex;
    width: 100%;
    align-items: center
}
	div.input {
    position: relative;
    width: 100%
}
	.trailing-icon {
    pointer-events: auto;
    position: relative;
    top: 32px;
    right: 0px;
    display: flex;
    align-items: center;
    padding-right: 0.875rem
}
</style>
